import { PALLET_ORANGE_CASES, WASHING_PALLETIZE_PALLET_MIN_WEIGHT } from "../../../helpers/constants";

export const getTotalPalletKg = (pallets = []) => {
    const total = pallets.reduce(
        (sum, p) => sum + parseFloat(p.pallet_kg_entered || 0),
        0
    );
    return Math.round(total * 1000) / 1000;
};

export const calculateGreenBoxes = (value) => {
    return Math.round(value / 28);
};

export const calculateOrangeBoxes = (value) => {
    // if (value >= WASHING_PALLETIZE_PALLET_MIN_WEIGHT) {
    //     return PALLET_ORANGE_CASES;
    // }
    return Math.round(value / 25);
};

export const getAreaLabel = (area, _t = (x) => x) => {
    if (area.value === "cold_storage" || area.value === "sorting") {
        return area.label;
    }
    const remaining_cases = area.cases_capacity - area.total_cases;
    return `${area.label} (${remaining_cases} ${_t("cases", "Cases")})`;
};

export const getSelectedArea = (selectedAreaId, allAreas = []) => {
    return allAreas.find((area) => area.value == selectedAreaId) || null;
};

export const getPalletAreaLabel = (area) => {
    let label = "";
    if (area === "cold_storage") {
        label = "Cold Storage";
    }
    if (area === "ripening") {
        label = "Ripening";
    }
    if (area === "sorting") {
        label = "Sorting";
    }
    return label;
};